import { create } from './table-schema';
import useTranslation from '../../hooks/useTranslation';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import timeFormAPI from '../../api/ui/timeFormAPI';
import { convertBigNumToDecimalString } from '../../utils/convert-decimal-to-big-num';
import {getGrayStateIcon, getOrangeStateIcon} from "../../api/ui/icons";

function useSchemaPartnerManage() {
  const { t } = useTranslation();
  const locale = useSelector((state) => state.language.locale);

  /**
   * 테이블 헤더에 표시할 항목 문자열 배열
   */
  const headerKeys = [
    'admin.event.newUser.partnerManageMain.table.head.accountNo', // "ID",
    'admin.event.newUser.partnerManageMain.table.head.email', // "이메일",
    'admin.event.newUser.partnerManageMain.table.head.enabled', // "활성화 여부",
    'admin.event.newUser.partnerManageMain.table.head.invCode', // "추천 코드",
    'admin.event.newUser.partnerManageMain.table.head.userCount', // "추천 유저 수",
    'admin.event.newUser.partnerManageMain.table.head.buyerCount', // "추천 NFT 구입 횟수",
    'admin.event.newUser.partnerManageMain.table.head.rewardPer', // "지금된 총 보상 합계",
    'admin.event.newUser.partnerManageMain.table.head.createdAt', // "파트너사 등록 일시"
  ];

  /**
   * 서버로부터 전달받은 request를 테이블에 표시할 내용으로 변환한다.
   *
   * 오브젝트 키는 param1, param10 등의 형식으로 param 다음에 숫자를 붙여서 사용한다.
   *
   * param1은 헤더의 첫번째 표시되는 항목이다.
   *
   * 헤더에는 표시되지 않지만 상세에 표시될 항목의 경우 headSize 이후의 숫자를 사용한다.
   *
   * key는 반드시 있어야 한다.
   * @param {object} row
   * @returns
   */
  const parse = (row) => {
    const accountNo = row?.accountNo;
    const email = row?.email;
    const invCode = row?.invCode;
    const enabled = row?.enabled ? getOrangeStateIcon("활성") : getGrayStateIcon("비활성");
    const userCount = row?.userCount;
    const buyerCount = row?.buyerCount;
    const rewardPer = convertBigNumToDecimalString(row?.rewardPer, 3) || 0;
    const createdAt = timeFormAPI.changeDataLog(row?.createdAt);

    return {
      key: accountNo, // 키는 반드시 있어야 한다.
      param1: accountNo,
      param2: email,
      param3: enabled,
      param4: invCode,
      param5: userCount,
      param6: buyerCount,
      param7: rewardPer,
      param8: createdAt,
      accountNo: accountNo,
    };
  };

  /**
   * 로그 데이터를 클릭했을 때 보여줄 디테일 다이얼로그에 보여줄 항목을 작성한다.
   *
   * 입력값인 row는 위의 parse에서 변환된 값이다.
   *
   * @param {object} row
   * @returns
   */
  const details = (row) => {
    const array = [];
    if (row) {
      //
    }
    return array;
  };

  const [schema, setSchema] = useState();

  useEffect(() => {
    const headers = headerKeys.map((key) => t(key));
    const schema = create({
      heads: headers,
      parseFunc: parse,
      detailFunc: details,
    });
    setSchema(schema);
  }, [locale]);

  return { schema: schema };
}

export default useSchemaPartnerManage;
